import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import Loading from '../../components/Loading/Loading';
import { auth } from '../../lib/firebase';

const ClassroomRoutes = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const checkAccess = (user) => {
      const schoolCode = localStorage.getItem('school_code');

      // If there's a school code but no user, they're accessing via classroom mode
      const access = !!schoolCode || !!user;

      setHasAccess(access);
      setIsLoading(false);
    };

    const unsubscribe = auth.onAuthStateChanged((user) => {
      checkAccess(user);
    });

    return unsubscribe;
  }, []);

  if (isLoading) return <Loading />;
  return hasAccess ? <Outlet /> : <Navigate to="/access" replace />;
};

export default ClassroomRoutes;
